import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface GlobalFilters {
  dateRange: string;
  country: string;
  timezone: string;
}

interface GlobalState {
  // 全局过滤器
  filters: GlobalFilters;

  // 全局加载状态
  isGlobalLoading: boolean;

  // 全局通知
  notifications: Array<{
    id: string;
    type: 'success' | 'error' | 'warning' | 'info';
    message: string;
    timestamp: number;
  }>;

  // Actions
  setFilters: (filters: Partial<GlobalFilters>) => void;
  setGlobalLoading: (loading: boolean) => void;
  addNotification: (
    notification: Omit<GlobalState['notifications'][0], 'id' | 'timestamp'>
  ) => void;
  removeNotification: (id: string) => void;
  clearNotifications: () => void;
  clearNotificationsByType: (type: 'success' | 'error' | 'warning' | 'info') => void;
}

export const useGlobalStore = create<GlobalState>()(
  persist(
    set => ({
      // Initial state
      filters: {
        dateRange: '12months',
        country: 'All',
        timezone: 'UTC',
      },

      isGlobalLoading: false,
      notifications: [],

      // Actions
      setFilters: filters =>
        set(state => ({
          filters: { ...state.filters, ...filters },
        })),

      setGlobalLoading: loading => set({ isGlobalLoading: loading }),

      addNotification: notification =>
        set(state => ({
          notifications: [
            ...state.notifications,
            {
              ...notification,
              id: Math.random().toString(36).substring(7),
              timestamp: Date.now(),
            },
          ],
        })),

      removeNotification: id =>
        set(state => ({
          notifications: state.notifications.filter(n => n.id !== id),
        })),

      clearNotifications: () => set({ notifications: [] }),
      
      clearNotificationsByType: (type) => 
        set(state => ({
          notifications: state.notifications.filter(n => n.type !== type),
        })),
    }),
    {
      name: 'global-store',
      partialize: state => ({ filters: state.filters }), // Only persist filters
    }
  )
);
